import { DependenciesInjection } from "app/di/DependencyInjection";
import { StoreImpl } from "../data/StoreImpl";
import { IStoreRepository } from "../domain/repositories/IStoreRepository";
import { StoreUseCase } from "../domain/useCases/StoreUseCase";
import { StoreToken } from "./StoreToken";
import { StoreManagementViewModel } from "../presentation/viewModel/StoreManagementViewModel";

export class StoreInjection {
  static initInjections() {
    DependenciesInjection.register<IStoreRepository>(
      StoreToken.IStoreRepository,
      StoreImpl,
      "otherRepo",
    );
    DependenciesInjection.register<StoreUseCase>(
      StoreToken.StoreUseCase,
      StoreUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<StoreManagementViewModel>(
      StoreToken.StoreViewModel,
      StoreManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IStoreRepository>(
      StoreToken.IStoreRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<StoreUseCase>(
      StoreToken.StoreUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<StoreManagementViewModel>(
      StoreToken.StoreViewModel,
    );
  }
}
